// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cover-mode[data-v-e3e09cf8] {\n  width: 100%;\n  height: calc(var(--vh) * 100);\n  background: #fff;\n}\n.cover-mode .cover-img[data-v-e3e09cf8] {\n  width: 3.04rem;\n  height: 3.76rem;\n  margin: 3.46667rem 0 0.64rem;\n}\n.cover-mode .cover-slogan[data-v-e3e09cf8] {\n  width: 0.50667rem;\n  height: 116;\n}\n", ""]);
// Exports
module.exports = exports;
